import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.repeat.js";
export function obfuscatePhoneNumber(phoneNumber) {
  var number = phoneNumber.length > 3 ? phoneNumber : '12345678';
  var last3Digits = number.slice(-3);
  var obfuscatedDigits = '*'.repeat(number.length - 3);
  return obfuscatedDigits + last3Digits;
}
export var MIN_WHATSAPP_PHONE_NUMBER_LENGTH = 6;
export var COUNTDOWN_DURATION = 90;